import { StyleProp, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { nativewindWrapSvg } from './wrapSvg';
function ArrowDownIconRaw({
  style,
  fill,
}: {
  style?: StyleProp<ViewStyle>;
  fill?: string;
  className?: string;
}) {
  return (
    <Svg width="36" height="36" viewBox="0 0 36 36" fill={fill} style={style}>
      <Path
        d="M18.1055 4.5V29.745M27.21 20.895L18.105 30L9 20.895"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export const ArrowDownIcon = nativewindWrapSvg(ArrowDownIconRaw);
